import { render, staticRenderFns } from "./SupplierCreateTemplate.vue?vue&type=template&id=096827e3&"
import script from "./SupplierCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./SupplierCreateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('096827e3')) {
      api.createRecord('096827e3', component.options)
    } else {
      api.reload('096827e3', component.options)
    }
    module.hot.accept("./SupplierCreateTemplate.vue?vue&type=template&id=096827e3&", function () {
      api.rerender('096827e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/SupplierCreateTemplate.vue"
export default component.exports